/* eslint-disable @typescript-eslint/camelcase */

import { combineReducers } from 'redux';
import * as Actions from './ProfileActions';
import RiskTolerance from './RiskTolerance/RiskToleranceReducer';

const BASE_CLIENT_OBJECT = {
  clientId: null,
};

const initialState = {
  current_clientId: null,
  isAdviserArea: false,

  page: null,
  pivotId: null,
  stepId: null,
};

const ProfileReducer = (state = initialState, action) => {
  let client_obj = {};
  switch (action.type) {
    case Actions.INITIALIZE_SECTION:
      client_obj = {
        [action.clientId]: BASE_CLIENT_OBJECT,
        current_clientId: action.clientId,
        isAdviserArea: action.isAdviserArea,
        page: action.page,
        pivotId: action.pivotId,
        stepId: action.stepId,
      };
      return { ...state, ...client_obj };

    default:
      return state;
  }
};

export default combineReducers({
  Main: ProfileReducer,
  RiskTolerance,
});
